import Vue from 'vue'
import Vuex, { Store, StoreOptions } from 'vuex'
import createLogger from 'vuex/dist/logger'
import { DEBUG } from '@/config'

import orderForm from './mod/order_form'
import serviceForm from './mod/service_form'
import auth from './mod/auth'
import install from './mod/install'

Vue.use(Vuex)

export default new Store({
  modules: {
    orderForm,
    serviceForm,
    auth,
    install,
  },
  strict: DEBUG,
  plugins: DEBUG ? [createLogger({})] : []
})
